import { TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DATE_FORMAT_DISPLAY } from "AppConstants";
import MDBox from "components/MDBox";
import dayjs from "dayjs";
import { getLatestActivityDate } from "utils/dateUtil";
import "./CustomDateOption.css";

export const CustomDateOption = ({activityStartDate, activityEndDate, updateStartDateHandler, updateEndDateHandler}) => {
    return (<>
        <MDBox className="custom-date-option-input">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              maxDate={dayjs(getLatestActivityDate())}
              label="Start Date"
              value={activityStartDate ? dayjs(activityStartDate) : null}
              onChange={updateStartDateHandler}
              renderInput={(params) => <TextField {...params} />}
              inputFormat={DATE_FORMAT_DISPLAY}
            />
          </LocalizationProvider>
        </MDBox>
        <MDBox className="custom-date-option-input">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="End Date"
              value={activityEndDate ? dayjs(activityEndDate) : null}
              onChange={updateEndDateHandler}
              renderInput={(params) => <TextField {...params} />}
              inputFormat={DATE_FORMAT_DISPLAY}
            />
          </LocalizationProvider>
        </MDBox>
      </>);
}